module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1116.2221bffd.png";